module.exports = __webpack_public_path__ + "img/titelbalk.f2764792.png";